export interface Instructor {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  password: string;
  password_repeat: string;
  verified_email: boolean;
}

export function createEmptyInstructor(): Instructor {
  return {
    id: 0,
    name: '',
    email: '',
    phone_number: '',
    password: '',
    password_repeat: '',
    verified_email: false,
  };
}

export function instructorToSignUpPayload(i: Instructor) {
  return {
    name: i.name,
    email: i.email,
    phone_number: i.phone_number,
    password: i.password
  };
}

export function instructorToSignInPayload(i: Instructor) {
  return {
    email: i.email,
    password: i.password,
  };
}

export function instructorPersonalDetailsUpdatePayload(i: Instructor) {
  return {
    id: i.id,
    name: i.name,
    phone_number: i.phone_number
  };
}

export function instructorChangePasswordPayload(i: Instructor) {
  return {
    id: i.id,
    old_password: i.password,
    new_password: i.password_repeat,
  };
}
